import classNames from 'classnames';
import { format } from 'date-fns';
import { FaComments, FaComment } from 'react-icons/fa';
import { HiChatAlt } from 'react-icons/hi';
import { BsPlusCircle } from 'react-icons/bs';
import { FiFileText } from 'react-icons/fi';

export const founderData = [
  {
    investor: 'John Doe',
    stage: 'Initial Meeting',
    amount: 500000,
    percentage: 10,
    status: 'In Progress',
    lastUpdated: 'January 1, 2025',
  },
  {
    investor: 'Jane Smith',
    stage: 'Due Diligence',
    amount: 1000000,
    percentage: 20,
    status: 'Term Sheet Signed',
    lastUpdated: 'January 1, 2025',
  },
  {
    investor: 'Alpha Ventures',
    stage: 'Closed Deal',
    amount: 750000,
    percentage: 15,
    status: 'Closed',
    lastUpdated: 'December 30, 2024',
  },
];

export const investorData = [
  {
    founder: 'John Doe',
    stage: 'Initial Meeting',
    amount: 500000,
    percentage: 10,
    status: 'In Progress',
    lastUpdated: 'January 1, 2025',
  },
  {
    founder: 'Jane Smith',
    stage: 'Due Diligence',
    amount: 1000000,
    percentage: 20,
    status: 'Term Sheet Signed',
    lastUpdated: 'January 1, 2025',
  },
  {
    founder: 'Alpha Ventures',
    stage: 'Closed Deal',
    amount: 750000,
    percentage: 15,
    status: 'Closed',
    lastUpdated: 'December 30, 2024',
  },
];

export const founderColumns = [
  {
    header: 'Name',
    accessorKey: 'name',
  },
  {
    header: 'Stage of Interaction',
    accessorKey: 'stage_of_interaction',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        <span className={`px-2 py-1 text-sm capitalize`}>
          {value.replace(/[^A-Za-z\s]/, ' ')}
        </span>
      );
    },
  },
  {
    header: 'Total Amount Committed',
    accessorKey: 'amount_committed',
    cell: ({ getValue }) => {
      const value = getValue();
      return value !== undefined && value !== null
        ? `$${value.toLocaleString()}`
        : '-';
    },
  },
  {
    header: 'No of signed termsheets',
    accessorKey: 'no_of_investors',
  },
  {
    header: 'No of pending termsheets',
    accessorKey: 'open_termsheets',
  },
  {
    header: 'Total Percentage',
    accessorKey: 'percentage',
    cell: ({ getValue }) => {
      const value = getValue();
      return value ? `${value * 100}%` : '-';
    },
  },
  {
    header: 'Status',
    accessorKey: 'status',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        <span
          className={classNames('px-2 py-1 rounded-full text-sm capitalize', {
            'text-green-600': value === 'in_progress',
            'text-[#134A70]': value === 'signed',
            'text-red-600': value === 'closed',
          })}
        >
          {value.replace(/[^A-Za-z\s]/, ' ')}
        </span>
      );
    },
  },
  {
    header: 'Last Updated',
    accessorKey: 'updatedAt',
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return '-';

      try {
        return format(new Date(value), 'MMM d, yyyy');
      } catch (error) {
        return '-';
      }
    },
  },
  {
    header: '',
    accessorKey: 'actions',
    cell: ({ row, onActionClick }) => {
      if (row.original.status === 'closed') {
        return (
          <div className="text-center text-gray-600">Deal already closed</div>
        );
      } else {
        return (
          <div className="flex items-center justify-center w-full">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onActionClick(row.original);
              }}
              className="p-2 rounded-full hover:bg-gray-100 transition-colors duration-200 text-gray-600 hover:text-red-600 group relative"
              title="Close Deal"
            >
              <span className="absolute invisible group-hover:visible bg-gray-800 text-white text-xs rounded py-1 px-2 -top-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap">
                Close Deal Flow
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8"
                />
              </svg>
            </button>
          </div>
        );
      }
    },
  },
];

export const closedDealFounderColumns = [
  {
    header: 'Name',
    accessorKey: 'name',
  },
  {
    header: 'Stage of Interaction',
    accessorKey: 'stage_of_interaction',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        <span className={`px-2 py-1 text-sm capitalize`}>
          {value.replace(/[^A-Za-z\s]/, ' ')}
        </span>
      );
    },
  },
  {
    header: 'Total Amount Committed',
    accessorKey: 'amount_committed',
    cell: ({ getValue }) => {
      const value = getValue();
      return value !== undefined && value !== null
        ? `$${value.toLocaleString()}`
        : '-';
    },
  },
  {
    header: 'No of signed termsheets',
    accessorKey: 'no_of_investors',
  },
  {
    header: 'No of rejected termsheets',
    accessorKey: 'rejected_termsheets',
  },
  {
    header: 'Total Percentage',
    accessorKey: 'percentage',
    cell: ({ getValue }) => {
      const value = getValue();
      return value ? `${value * 100}%` : '-';
    },
  },
  {
    header: 'Status',
    accessorKey: 'status',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        <span
          className={classNames('px-2 py-1 rounded-full text-sm capitalize', {
            'text-green-600': value === 'in_progress',
            'text-[#134A70]': value === 'signed',
            'text-red-600': value === 'closed',
          })}
        >
          {value.replace(/[^A-Za-z\s]/, ' ')}
        </span>
      );
    },
  },
  {
    header: 'Last Updated',
    accessorKey: 'updatedAt',
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return '-';

      try {
        return format(new Date(value), 'MMM d, yyyy');
      } catch (error) {
        return '-';
      }
    },
  },
];

export const investorColumns = [
  {
    header: 'Founder',
    accessorKey: 'user',
    cell: ({ getValue }) => {
      const value = getValue();
      const fullName = `${value?.first_name} ${value?.last_name}`;
      return fullName;
    },
  },
  {
    header: 'Name',
    accessorKey: 'name',
  },
  {
    header: 'Stage of Interaction',
    accessorKey: 'stage_of_interaction',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        <span className={`px-2 py-1 text-sm capitalize`}>
          {value.replace(/[^A-Za-z\s]/, ' ')}
        </span>
      );
    },
  },
  {
    header: 'Company Name',
    accessorKey: 'company.title',
  },
  {
    header: 'Company Valuation',
    accessorKey: 'company.valuation',
    cell: ({ getValue }) => {
      const value = getValue();
      return value !== undefined && value !== null
        ? `$${value.toLocaleString()}`
        : '-';
    },
  },
  {
    header: 'Amount Committed',
    accessorKey: 'amount_committed',
    cell: ({ getValue }) => {
      const value = getValue();
      return value !== undefined && value !== null
        ? `$${value.toLocaleString()}`
        : '-';
    },
  },
  // {
  //   header: 'Percentage',
  //   accessorKey: 'percentage',
  //   cell: ({ getValue }) => {
  //     const value = getValue();
  //     return value ? `${value}%` : '-';
  //   },
  // },
  {
    header: 'Status',
    accessorKey: 'status',
    cell: ({ getValue }) => {
      const value = getValue();

      return (
        <span
          className={classNames('px-2 py-1 capitalize rounded-full text-sm', {
            'text-green-600': value === 'in_progress',
            'text-[#134A70]': value === 'signed',
            'text-red-600': value === 'closed',
          })}
        >
          {value.replace(/[^A-Za-z\s]/, ' ')}
        </span>
      );
    },
  },
  {
    header: 'Last Updated',
    accessorKey: 'updatedAt',
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return '-';

      try {
        return format(new Date(value), 'MMM d, yyyy');
      } catch (error) {
        return '-';
      }
    },
  },
];

export const termsheetCoulmns = [
  { header: 'Deal Id', accessorKey: 'deal_id' },
  {
    header: 'Investor Name',
    accessorKey: 'investor.user',
    cell: ({ getValue }) => {
      const value = getValue();

      return `${value?.first_name} ${value?.last_name}`;
    },
  },
  {
    header: 'Amount Committed',
    accessorKey: 'investment_amount',
    cell: ({ getValue }) => {
      const value = getValue();
      return `$${Number(value).toLocaleString()}`;
    },
  },
  {
    header: 'Status',
    accessorKey: 'status',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        <span
          className={classNames('px-2 py-1 capitalize rounded-full text-sm', {
            'text-green-600': value === 'in_progress',
            'text-[#134A70]': value === 'signed',
            'text-red-600': value === 'rejected',
          })}
        >
          {value.replace('_', ' ')}
        </span>
      );
    },
  },
  {
    header: 'Equity percentage',
    accessorKey: 'equity_percentage',
    cell: ({ getValue }) => {
      const value = getValue();
      return `${value * 100}%` || 0;
    },
  },

  {
    header: 'CreatedAt',
    accessorKey: 'createdAt',
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return '-';

      try {
        return format(new Date(value), 'MMM d, yyyy');
      } catch (error) {
        return '-';
      }
    },
  },
  {
    header: 'Last Updated',
    accessorKey: 'updatedAt',
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return '-';

      try {
        return format(new Date(value), 'MMM d, yyyy');
      } catch (error) {
        return '-';
      }
    },
  },
];


export const invitesColumns = [
  {
    header: 'Investor',
    accessorKey: 'investor',
    cell: ({ getValue, row, onConnect, onMessage }) => {
      const { id, first_name, last_name } = getValue();
      const fullName = `${first_name} ${last_name}`;
      const connection = row.original?.connections;
      const hasConnection = connection !== null && connection !== undefined;

      return (
        <div className="flex items-center gap-3">
          <span className="font-medium">{fullName}</span>
          {hasConnection ? (
            <button
              className="relative p-2 rounded-lg hover:bg-blue-50 transition-all duration-200 group border border-transparent hover:border-blue-200"
              onClick={(e) => {
                e.stopPropagation();
                onMessage?.(row.original);
              }}
            >
              <span className="absolute invisible group-hover:visible bg-gray-800 text-white text-xs rounded py-1 px-2 -top-10 left-1/2 transform -translate-x-1/2 whitespace-nowrap z-10">
                Send message
              </span>
              <HiChatAlt className="text-gray-500 group-hover:text-blue-600 w-5 h-5 transition-colors duration-200" />
            </button>
          ) : (
            <button
              className="relative p-2 rounded-lg hover:bg-blue-50 transition-all duration-200 group border border-transparent hover:border-blue-200"
              onClick={(e) => {
                e.stopPropagation();
                onConnect?.(row.original);
              }}
            >
              <span className="absolute invisible group-hover:visible bg-gray-800 text-white text-xs rounded py-1 px-2 -top-10 left-1/2 transform -translate-x-1/2 whitespace-nowrap z-10">
                Connect & Follow
              </span>
              <BsPlusCircle className="text-gray-500 group-hover:text-blue-600 w-5 h-5 transition-colors duration-200" />
            </button>
          )}
        </div>
      );
    },
  },
  {
    header: 'Profile Status',
    accessorKey: 'status',
    cell: ({ getValue }) => {
      const value = getValue();
      const isLive = value?.toLowerCase() === 'live';
      return (
        <div
          className={`px-3 py-1 rounded-lg inline-block ${isLive ? 'bg-[#DCFCE7]' : 'bg-[#F3F4F6]'
            } text-sm font-medium capitalize`}
        >
          {value}
        </div>
      );
    },
  },
  {
    header: 'Request',
    cell: ({ row, onCreateDeal }) => {
      const actions = row.original?.actions;

      if (!actions || !Array.isArray(actions) || actions.length === 0) {
        return <div className="text-gray-400">-</div>;
      }

      // Filter valid actions
      const validActions = actions.filter((actionObj) => actionObj?.action);

      if (validActions.length === 0) {
        return <div className="text-gray-400">-</div>;
      }

      // Format action name (convert "create_deal" to "Create Deal")
      const formatActionName = (action) => {
        return action
          .split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      };

      return (
        <div className="flex flex-wrap gap-2">
          {validActions.map((actionObj, index) => {
            const actionName = formatActionName(actionObj.action);
            return (
              <button
                key={actionObj.id || index}
                className="relative px-3 py-1.5 bg-[#134A70] text-white text-xs font-medium rounded-lg hover:bg-[#0f3a5a] transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed group"
                onClick={(e) => {
                  e.stopPropagation();
                  if (actionObj.action === 'create_deal') {
                    onCreateDeal?.(actionObj);
                  }
                }}
              >
                {actionName}
              </button>
            );
          })}
        </div>
      );
    },
  }
]



export const founderPipelineColumns = [
  {
    header: 'Founder',
    accessorKey: 'founder',
    cell: ({ getValue, row, onConnect, onMessage }) => {
      const { id, first_name, last_name } = getValue();
      const fullName = `${first_name} ${last_name}`;
      const connection = row.original?.connections;
      const hasConnection = connection !== null && connection !== undefined;

      return (
        <div className="flex items-center gap-3">
          <span className="font-medium">{fullName}</span>
          {hasConnection ? (
            <button
              className="relative p-2 rounded-lg hover:bg-blue-50 transition-all duration-200 group border border-transparent hover:border-blue-200"
              onClick={(e) => {
                e.stopPropagation();
                onMessage?.(row.original);
              }}
            >
              <span className="absolute invisible group-hover:visible bg-gray-800 text-white text-xs rounded py-1 px-2 -top-10 left-1/2 transform -translate-x-1/2 whitespace-nowrap z-10">
                Send message
              </span>
              <HiChatAlt className="text-gray-500 group-hover:text-blue-600 w-5 h-5 transition-colors duration-200" />
            </button>
          ) : (
            <button
              className="relative p-2 rounded-lg hover:bg-blue-50 transition-all duration-200 group border border-transparent hover:border-blue-200"
              onClick={(e) => {
                e.stopPropagation();
                onConnect?.(row.original);
              }}
            >
              <span className="absolute invisible group-hover:visible bg-gray-800 text-white text-xs rounded py-1 px-2 -top-10 left-1/2 transform -translate-x-1/2 whitespace-nowrap z-10">
                Connect & Follow
              </span>
              <BsPlusCircle className="text-gray-500 group-hover:text-blue-600 w-5 h-5 transition-colors duration-200" />
            </button>
          )}
        </div>
      );
    },
  },
  {
    header: 'Profile Status',
    accessorKey: 'status',
    cell: ({ getValue }) => {
      const value = getValue();
      const isLive = value?.toLowerCase() === 'live';
      return (
        <div
          className={`px-3 py-1 rounded-lg inline-block ${isLive ? 'bg-[#DCFCE7]' : 'bg-[#F3F4F6]'
            } text-sm font-medium capitalize`}
        >
          {value}
        </div>
      );
    },
  },
  {
    header: 'Deal',
    accessorKey: 'termsheet_id',
    cell: ({ getValue, row, onRequestDeal, onCreateTermsheet, requestDealLoading }) => {
      const value = getValue();
      const hasDeal = row.original?.hasDeal;
      const hasRequested = row.original?.actions?.some((action) => action?.action === 'create_deal') ?? false;

      // If already requested, show non-clickable "Requested" status
      if (hasRequested) {
        return (
          <div className="px-3 py-2 text-sm font-medium text-gray-500">
            Requested
          </div>
        );
      }

      // If founder doesn't have a deal, show "Request" button to request founder to create a deal
      if (!hasDeal) {
        return (
          <button
            className="relative flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-blue-50 transition-all duration-200 group border border-transparent hover:border-blue-200 text-sm font-medium text-[#134A70] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
            onClick={(e) => {
              e.stopPropagation();
              if (!requestDealLoading) {
                onRequestDeal?.(row.original);
              }
            }}
            disabled={requestDealLoading}
          >
            {requestDealLoading ? (
              <>
                <svg
                  className="animate-spin h-5 w-5 text-[#134A70]"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span>Requesting...</span>
              </>
            ) : (
              <>
                <BsPlusCircle className="w-5 h-5" />
                <span>Request</span>
              </>
            )}
            {!requestDealLoading && (
              <span className="absolute invisible group-hover:visible bg-gray-800 text-white text-xs rounded py-1 px-2 -top-10 left-1/2 transform -translate-x-1/2 whitespace-nowrap z-10">
                Request Founder to Create Deal
              </span>
            )}
          </button>
        );
      }

      // If founder has a deal but investor hasn't submitted termsheet, show "Create Termsheet" button
      if (hasDeal && (value === null || value === undefined)) {
        return (
          <button
            className="relative flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-blue-50 transition-all duration-200 group border border-transparent hover:border-blue-200 text-sm font-medium text-[#134A70]"
            onClick={(e) => {
              e.stopPropagation();
              onCreateTermsheet?.(row.original);
            }}
          >
            <FiFileText className="w-5 h-5" />
            <span>Draft Term Sheet</span>
            <span className="absolute invisible group-hover:visible bg-gray-800 text-white text-xs rounded py-1 px-2 -top-10 left-1/2 transform -translate-x-1/2 whitespace-nowrap z-10">
              Draft Term Sheet
            </span>
          </button>
        );
      }

      // If termsheet exists, show the value
      return <div>-</div>;
    },
  }
]


export const founderPipelineData = [
  {
    id: 1,
    name: 'Nicholas Gordon',
    status: 'live',
    termSheet: 'Accept',
  },
  {
    id: 2,
    name: 'Sarah Chen',
    status: 'draft',
    termSheet: 'Accept',
  },
  {
    id: 3,
    name: 'David Okonkwo',
    status: 'live',
    termSheet: 'Accept',
  },
]


export const invitesData = [
  {
    id: 1,
    name: 'Nicholas Gordon',
    status: 'live',
    request: 'Accept',
  },
  {
    id: 2,
    name: 'Sarah Chen',
    status: 'draft',
    request: 'Accept',
  },
  {
    id: 3,
    name: 'David Okonkwo',
    status: 'live',
    request: 'Accept',
  },
  // {
  //   id: 4,
  //   name: 'Maria Santos',
  //   message: 'Hello, I am interested in your company',
  //   status: 'live',
  //   request: 'Accept',
  // },
  // {
  //   id: 5,
  //   name: 'James Wilson',
  //   message: 'Hello, I am interested in your company',
  //   status: 'draft',
  //   request: 'Accept',
  // },
]


export const investors = [
  {
    id: 1,
    name: 'Nicholas Gordon',
    email: 'nicholasgordon@gmail.com',
    phone: '+2348060000000',
    company: 'Tech Solutions',
    location: 'Lagos, Nigeria',
  },
  {
    id: 2,
    name: 'Sarah Chen',
    email: 'sarah.chen@ventures.com',
    phone: '+2348061111111',
    company: 'Global Ventures Capital',
    location: 'Abuja, Nigeria',
  },
  {
    id: 3,
    name: 'David Okonkwo',
    email: 'david.o@investafrica.com',
    phone: '+2348062222222',
    company: 'InvestAfrica Partners',
    location: 'Port Harcourt, Nigeria',
  },
  {
    id: 4,
    name: 'Maria Santos',
    email: 'maria.s@techfund.com',
    phone: '+2348063333333',
    company: 'TechFund Innovation',
    location: 'Kano, Nigeria',
  },
  {
    id: 5,
    name: 'James Wilson',
    email: 'jwilson@capitalgroup.com',
    phone: '+2348064444444',
    company: 'Capital Group Africa',
    location: 'Ibadan, Nigeria',
  },
  {
    id: 6,
    name: 'Aisha Mohammed',
    email: 'aisha.m@futureventures.com',
    phone: '+2348065555555',
    company: 'Future Ventures',
    location: 'Kaduna, Nigeria',
  },
  {
    id: 7,
    name: 'Robert Zhang',
    email: 'robert.z@asiacapital.com',
    phone: '+2348066666666',
    company: 'Asia-Africa Capital',
    location: 'Enugu, Nigeria',
  },
  {
    id: 8,
    name: 'Chioma Adebayo',
    email: 'chioma.a@nexgen.com',
    phone: '+2348067777777',
    company: 'NexGen Investments',
    location: 'Benin City, Nigeria',
  },
  {
    id: 9,
    name: 'Michael Osei',
    email: 'michael.o@panafric.com',
    phone: '+2348068888888',
    company: 'PanAfrican Ventures',
    location: 'Calabar, Nigeria',
  },
  {
    id: 10,
    name: 'Michael Osei',
    email: 'michael.o@panafric.com',
    phone: '+2348068888888',
    company: 'PanAfrican Ventures',
    location: 'Calabar, Nigeria',
  },
];
